<template>
  <div class="form-group form-range-div">
    <div :class="hasIcon(icon)">
      <label class="range-control-label" :for="id">{{ label }}</label>
      <div class="range-wrapper">
        <input
          ref="range"
          :id="id"
          type="range"
          class="form-range"
          :class="getClasses(size, success, error)"
          :name="name"
          :min="min"
          :max="max"
          :step="step"
          :value="modelValue"
          @input="handleInput"
          @change="handleChange"
        />

        <span
          v-if="showValue"
          class="range-value-bubble pt-0 pb-0"
          :style="valueStyle"
        >
          {{ modelValue }} <small v-if="unidades">{{ unidades }}</small>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SoftRange",
  props: {
    modelValue: {
      type: [Number, String],
      default: 0
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    step: {
      type: Number,
      default: 1
    },
    size: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    unidades: {
      type: String,
      default: ""
    },
    success: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ""
    },
    iconDir: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: ""
    },
    showValue: {
      type: Boolean,
      default: true
    }
  },
  emits: ["update:modelValue", "range-input"],
  computed: {
    percent() {
      const min = Number(this.min);
      const max = Number(this.max);
      const val = Number(this.modelValue);
      if (isNaN(min) || isNaN(max) || max === min) return 0;
      return ((val - min) / (max - min)) * 100;
    },
    valueStyle() {
      // Position the bubble centered at the thumb using percent and translateX
      return {
        left: `${this.percent}%`,
        transform: "translateX(-50%)",
      };
    }
  },
  methods: {
    getClasses(size, success, error) {
      let sizeValue = size ? `form-range-${size}` : "";
      let isValidValue = "";

      if (error) {
        isValidValue = "is-invalid";
      } else if (success) {
        isValidValue = "is-valid";
      }

      return `${sizeValue} ${isValidValue}`.trim();
    },
    getIcon(icon) {
      return icon || null;
    },
    hasIcon(icon) {
      return icon ? "input-group" : null;
    },
    handleInput(event) {
      const val = Number(event.target.value);
      // update v-model immediately so UI (bubble) follows the thumb
      this.$emit("update:modelValue", val);
    },
    handleChange(event) {
      // emit only when the user finishes the change (releases the slider)
      const val = Number(event.target.value);
      this.$emit("range-input", val);
    }
  }
};
</script>

<style scoped>
.form-range-div {
  width: 250px;
  position: absolute;
  top: 5px;
  right: 45px;
  height: 30px;
  margin: 0;
}
.form-range-div .range-control-label {
  margin: 0;
  font-size: 14px;
  width: 120px;
  vertical-align: top;
  line-height: 26px;
}
.form-range-div .range-wrapper {
  width: 130px;
  height: 26px;
  display: inline-block;
  padding: 3px 0;
  position: relative;
}
.range-value-bubble {
  position: absolute;
  top: 100%;
  white-space: nowrap;
  background: #fff;
  color: #344767;
  font-size: 0.8125rem;
  padding: 4px 8px;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(16,24,40,0.08);
  border: 1px solid rgba(15,23,42,0.06);
  pointer-events: none;
  transition: left 0.08s linear;
  line-height: 20px;
}

/* make text inside unidades smaller */
.range-value-bubble small {
  font-size: 0.75rem;
  color: #333;
}
</style>
